"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mai = void 0;
exports.mai = {
    chef: '0xAB598434d0d0B1aDAf8311484A980d12169E035f',
};
